// Popper component cause a type error in production. This is the MUI bug.
// @ts-nocheck
import React, { FC, useCallback, SyntheticEvent } from 'react';
// mui components
import { Autocomplete, Grid, Popper, TextField, Typography, PopperProps } from '@mui/material';
import { makeStyles } from '@mui/styles';
// components
import Tag from '../../tag';
// types
import { ITag } from 'redux-store/types';
// styles
import { addTagButtonStyles } from '../styles';

export interface ITagsSelectProps {
  placeholder: string;
  value: ITag[];
  options: ITag[];
  type: 'profiles' | 'phases';
  handleChange: (selectedValues: ITag[]) => void;
  handleDelete: (itemId: number) => void;
}

const useStyles = makeStyles({
  parentContainer: addTagButtonStyles.autocompleteParentContainer,
});

const TAGS_SELECT_POPPER_Z_INDEX = 1501;

const CustomPopper: FC<PopperProps> = (props) => {
  return (
    <Popper
      {...props}
      placement="top"
      style={{
        ...props.style,
        zIndex: TAGS_SELECT_POPPER_Z_INDEX,
      }}
      sx={{
        ...props.sx,
        zIndex: TAGS_SELECT_POPPER_Z_INDEX,
      }}
    />
  );
};

const TagsSelect: FC<ITagsSelectProps> = ({
  placeholder,
  options,
  value,
  handleChange,
  handleDelete,
  type,
}) => {
  const classes = useStyles();

  const onOptionsChange = (e: SyntheticEvent<Element, Event>, selectedValues: ITag[]) => {
    handleChange(selectedValues);
  };

  const onDelete = useCallback((itemId: number) => {
    handleDelete(itemId);
  }, []);

  return (
    <Grid sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: '8px' }}>
      <Autocomplete
        multiple
        fullWidth
        disableClearable
        disableCloseOnSelect
        classes={{ paper: classes.parentContainer }}
        getOptionLabel={(option) => (typeof option === 'string' ? option : option.title)}
        isOptionEqualToValue={(option, val) => option.id === val.id}
        onChange={onOptionsChange}
        options={options}
        value={value}
        renderTags={() => null}
        renderOption={(props: any, option) => (
          <Grid {...props} key={option.id}>
            <Typography sx={addTagButtonStyles.optionValue}>{option.title}</Typography>
          </Grid>
        )}
        renderInput={(params) => (
          <TextField
            variant="outlined"
            placeholder={placeholder}
            sx={
              type === 'profiles'
                ? addTagButtonStyles.autocompleteInputProfiles
                : addTagButtonStyles.autocompleteInput
            }
            InputProps={{ endAdornment: true }}
            {...params}
            inputProps={{
              ...params.inputProps,
              autoComplete: 'off',
            }}
          />
        )}
        PopperComponent={CustomPopper}
      />
      <Grid sx={addTagButtonStyles.tagsContainer}>
        {value.map((option) => (
          <Tag key={option.id} onDelete={onDelete} option={option} />
        ))}
      </Grid>
    </Grid>
  );
};

export default TagsSelect;
